import { BAND_NAME, ago, bandBg, bandFg, statusOf, typeLabel, worstFinding } from './model';
import { monoLabel } from '../UI/ink';

const Glyph = ({ a }) => {
  const size = a.kind === 'network' ? 10 : 13;
  return (
    <span className="w-4 h-4 shrink-0 flex items-center justify-center" aria-hidden="true">
      <span
        className="box-border"
        style={{
          width: size, height: size,
          borderRadius: a.kind === 'server' ? 3 : a.kind === 'network' ? 1 : 7,
          border: `1.5px ${a.discovered ? 'dashed' : 'solid'} ${bandFg(a.band)}`,
          background: bandBg(a.band),
          transform: a.kind === 'network' ? 'rotate(45deg)' : undefined,
        }}
      />
    </span>
  );
};

const AssetList = ({ assets, byId, selectedId, onSelect }) => {
  const rows = assets.slice().sort((a, b) => (b.risk ?? -1) - (a.risk ?? -1));
  const th = `px-2 text-left font-medium ${monoLabel}`;
  return (
    <section aria-label="Assets" className="h-full min-h-[520px] rounded-[14px] border overflow-auto" style={{ background: 'var(--surf-surface)', borderColor: 'var(--surf-line)' }}>
      <table className="w-full min-w-[800px] border-collapse table-fixed">
        <thead className="sticky top-0 z-[1]" style={{ background: 'var(--surf-surface)' }}>
          <tr className="h-[42px] border-b" style={{ borderColor: 'var(--surf-line)', color: 'var(--ink-faint)' }}>
            <th scope="col" className={`${th} pl-4`}>ASSET</th>
            <th scope="col" className={`${th} w-[120px]`}>IP</th>
            <th scope="col" className={`${th} w-[128px]`}>RISK</th>
            <th scope="col" className={`${th} w-[80px]`}>ISSUES</th>
            <th scope="col" className={`${th} w-[104px]`}>STATUS</th>
            <th scope="col" className={`${th} w-[140px]`}>SOURCE</th>
            <th scope="col" className={`${th} w-[86px] pr-4`}>SEEN</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={7} className="h-32 text-center text-sm" style={{ color: 'var(--ink-faint)' }}>No assets match these filters.</td></tr>
          )}
          {rows.map(a => {
            const st = statusOf(a);
            const on = a.id === selectedId;
            const parent = a.discoveredBy ? byId[a.discoveredBy] : null;
            const worst = worstFinding(a.findings);
            return (
              <tr key={a.id} className="h-[50px] border-b" style={{ borderColor: 'var(--surf-line)', background: on ? 'var(--surf-raised)' : 'transparent' }}>
                <td className="pl-4 pr-2">
                  <button type="button" onClick={() => onSelect(on ? null : a.id)} aria-pressed={on} className="flex items-center gap-2.5 min-w-0 max-w-full text-left">
                    <Glyph a={a} />
                    <span className="flex flex-col gap-0.5 min-w-0">
                      <span className="font-mono text-[12.5px] truncate">{a.unnamed ? 'unknown' : a.host}</span>
                      <span className="text-[11.5px]" style={{ color: 'var(--ink-faint)' }}>{typeLabel(a.deviceType)}</span>
                    </span>
                  </button>
                </td>
                <td className="px-2 font-mono text-xs truncate" style={{ color: 'var(--ink-muted)' }}>{a.ip || '—'}</td>
                <td className="px-2">
                  <span className="inline-flex items-center gap-1.5 h-[22px] px-[7px] rounded-md font-mono text-[10.5px] font-medium tracking-[0.04em]" style={{ background: a.band === 'unk' ? 'var(--surf-raised)' : bandBg(a.band) }}>
                    <span className="w-1.5 h-1.5 rounded-[1px]" style={{ background: a.band === 'unk' ? 'transparent' : bandFg(a.band) }} />
                    {a.risk == null ? 'UNSCORED' : `${BAND_NAME[a.band]} ${a.risk}`}
                  </span>
                </td>
                <td className="px-2 font-mono text-xs" title={a.vulns ? `${a.vulns} open CVE${a.vulns === 1 ? '' : 's'}` : undefined}>
                  {worst
                    ? <span className="inline-flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full" style={{ background: bandFg(worst) }} />{a.findings.total}</span>
                    : <span style={{ color: 'var(--ink-faint)' }}>—</span>}
                </td>
                <td className="px-2">
                  <span className="flex items-center gap-1.5 text-[12.5px]"><span className="w-[7px] h-[7px] rounded-full" style={{ background: st.dot }} />{st.label}</span>
                </td>
                <td className="px-2 text-xs truncate" style={{ color: 'var(--ink-muted)' }}>
                  {a.discovered ? `via ${parent?.host || 'agent'}` : a.source === 'manual' ? 'Manual' : 'Agent'}
                </td>
                <td className="pl-2 pr-4 font-mono text-[11.5px]" style={{ color: 'var(--ink-faint)' }}>{ago(a.last_seen || a.created_at)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};

export default AssetList;
